module.exports = "/images/vendor/vue-paycard/src/7.jpg?c3ab3de66bd54e0aeee8351f33b89bdd";